import React from 'react';
import FontIcon from 'material-ui/FontIcon';

const data = {
  menus: [
    {
      id: 'dashboard',
      text: 'DashBoard',
      icon: <FontIcon className="material-icons">assessment</FontIcon>,
      url: '/dashboard',
      index: 0
    }
  ]
};

export default data;



// WEBPACK FOOTER //
// ./src/components/LeftDrawer/MenuItems/menudata.js